import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { createStructuredSelector } from 'reselect';
import { postComment } from './actions';
import { makeSelectLoadingSubmit } from './selectors';
import { withI18next } from '../../../hocs/_withI18next';
import {
  makeSelectProfile,
  makeSelectIsAuthenticated,
} from '../AuthProvider/selectors';
import Avatar from '~/components/Avatar';
import IconSendComment from '~/components/svg/send-comment.svg';
import themeVariables from '~/shared/themeVariables';

const Form = (props) => {
  const { loadingSubmit, data_id, profile, isAuthenticated, t } = props;
  const formik = useRef();
  const [countText, setCountText] = useState(0);
  const validate = (values) => {
    let errors = {};
    if (!values.text) {
      errors.text = 'Required';
    }
    return errors;
  };
  useEffect(() => {
    if (!loadingSubmit) {
      formik.current?.resetForm();
    }
  }, [loadingSubmit, formik]);

  const onSummit = async (values, action) => {
    if (values && isAuthenticated) {
      await props.postComment({
        user_id: profile.id,
        text: values,
        data_id: data_id,
      });
    }
  };
  const validateText = (e) => {
    setCountText(e.target.value.length);
  };
  return (
    <Formik
      initialValues={{ text: '' }}
      validate={validate}
      onSubmit={onSummit}
      ref={formik}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        form,
        field,
      }) => (
        <form className="container-form-comment" onSubmit={handleSubmit}>
          <div className="container-avatar">
            <Avatar
              src={
                profile.avatar || '/static/images/avatars/avatar_default.png'
              }
              size={56}
            />
          </div>
          <div className="container-input-form">
            <div className="container-input">
              <input
                name="text"
                className={`input-comment ${errors.text ? 'error-form' : ''} ${
                  loadingSubmit ? 'loadingSubmit' : ''
                }`}
                placeholder={t('add_your_comment')}
                onChange={(e) => {
                  // handleChange();
                  validateText(e);
                  setFieldValue('text', e.target.value);
                }}
                onBlur={handleBlur}
                value={values.text}
                disabled={loadingSubmit}
              />
              <div
                className={`container-icon-send ${
                  countText > 0 ? 'active-submit' : ''
                }`}
                onClick={handleSubmit}
              >
                <IconSendComment
                  color={countText > 0 ? themeVariables.color.primary : ''}
                />
              </div>
            </div>
          </div>
          <style jsx>{`
            .container-form-comment {
              height: 56px;
              display: flex;
              gap: 16px;
            }
            .container-input-form {
              width: 100%;
              height: 100%;
              display: flex;
            }
            .container-input {
              width: 100%;
              height: 100%;
              background-color: #f8f9fa;
              background-image: none;
              display: flex;
            }
            .container-icon-send {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding-right: 12px;
            }
            .active-submit {
              cursor: pointer;
            }
            .input-comment {
              width: 100%;
              height: 100%;
              padding: 6px 12px;
              font-size: 14px;
              color: #555;
              background-color: #f8f9fa;
              background-image: none;
              border: none;
            }
            .input-comment.loadingSubmit {
              color: grey;
            }
          `}</style>
        </form>
      )}
    </Formik>
  );
};

const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
  isAuthenticated: makeSelectIsAuthenticated(),
  loadingSubmit: makeSelectLoadingSubmit(),
});

const mapDispatchToProps = (dispatch) => ({
  postComment: (params) => dispatch(postComment(params)),
});

const Connector = connect(mapStateToProps, mapDispatchToProps)(Form);

export default Connector;
